/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrgRole {
  MANAGER = 'Manager',
  ADMIN = 'Admin',
  SUPERVISOR = 'Supervisor',
  EMPLOYEE = 'Employee',
}
